// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IResponseCipStatusDto } from './IResponseCipStatusDto';
import {
    IResponseCipStatusDtoFromJSON,
    IResponseCipStatusDtoFromJSONTyped,
    IResponseCipStatusDtoToJSON,
    IResponseCipStatusDtoToJSONTyped,
} from './IResponseCipStatusDto';

/**
 * 
 * @export
 * @interface IResponseCipInfoDto
 */
export interface IResponseCipInfoDto {
    /**
     * 
     * @type {number}
     * @memberof IResponseCipInfoDto
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof IResponseCipInfoDto
     */
    employee_id?: number;
    /**
     * 
     * @type {IResponseCipStatusDto}
     * @memberof IResponseCipInfoDto
     */
    current_cip_status?: IResponseCipStatusDto;
}

/**
 * Check if a given object implements the IResponseCipInfoDto interface.
 */
export function instanceOfIResponseCipInfoDto(value: object): value is IResponseCipInfoDto {
    return true;
}

export function IResponseCipInfoDtoFromJSON(json: any): IResponseCipInfoDto {
    return IResponseCipInfoDtoFromJSONTyped(json, false);
}

export function IResponseCipInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IResponseCipInfoDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'employee_id': json['employee_id'] == null ? undefined : json['employee_id'],
        'current_cip_status': json['current_cip_status'] == null ? undefined : IResponseCipStatusDtoFromJSON(json['current_cip_status']),
    };
}

export function IResponseCipInfoDtoToJSON(json: any): IResponseCipInfoDto {
    return IResponseCipInfoDtoToJSONTyped(json, false);
}

export function IResponseCipInfoDtoToJSONTyped(value?: IResponseCipInfoDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'employee_id': value['employee_id'],
        'current_cip_status': IResponseCipStatusDtoToJSON(value['current_cip_status']),
    };
}

